import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHouse,
  faStore,
  faUsers,
  faCog,
  faBook,
  faLayerGroup,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { NavBar, NavTab, NavIconPill, NavLabel } from './BottomNav.styles';

const MERCHANT_SIDE_ROLES = ['merchant', 'merchant_manager', 'merchant_staff', 'manager', 'staff'];

interface NavTabConfig {
  label: string;
  to: string;
  icon: IconDefinition;
}

const TABS_BY_ROLE_GROUP: Record<'admin' | 'merchant', NavTabConfig[]> = {
  admin: [
    { label: 'Dashboard', to: '/dashboard', icon: faHouse },
    { label: 'Merchants', to: '/merchants', icon: faUsers },
    { label: 'Stores', to: '/stores', icon: faLayerGroup },
    { label: 'Settings', to: '/settings', icon: faCog },
  ],
  merchant: [
    { label: 'Dashboard', to: '/dashboard', icon: faHouse },
    { label: 'Store', to: '/stores', icon: faStore },
    { label: 'Menu', to: '/menu', icon: faBook },
    { label: 'Settings', to: '/settings', icon: faCog },
  ],
};

interface BottomNavProps {
  role?: string;
}

const BottomNav: React.FC<BottomNavProps> = ({ role }) => {
  const location = useLocation();
  const { isDarkMode } = useTheme();

  const tabs = TABS_BY_ROLE_GROUP[MERCHANT_SIDE_ROLES.includes(role || '') ? 'merchant' : 'admin'];

  return (
    <NavBar $isDark={isDarkMode}>
      {tabs.map((tab) => {
        const isActive = location.pathname.startsWith(tab.to);
        return (
          <NavTab key={tab.to} to={tab.to} $active={isActive} $isDark={isDarkMode}>
            <NavIconPill $active={isActive}>
              <FontAwesomeIcon icon={tab.icon} />
            </NavIconPill>
            <NavLabel $active={isActive}>{tab.label}</NavLabel>
          </NavTab>
        );
      })}
    </NavBar>
  );
};

export default BottomNav;
